<div class="auth-callback">
  <p *ngIf="processing">{{ 'LOGIN.VERIFYING' | translate }}</p>
  <p *ngIf="error">{{ 'HEADER.VERIFICATION_FAILED' | translate }}</p>
</div>
